import { PROFILE_ROUTE_NAMES } from '../../../../../../constants/route'

export function getListingProfileTabUrl({ listingId, tab }) {
  return PROFILE_ROUTE_NAMES.rentalPortalListingProfile({
    additionalParams: `/${tab}`,
    id: listingId,
  })
}
